import { render, staticRenderFns } from "./BaseInputMultiple.vue?vue&type=template&id=bc63dfae&scoped=true&"
import script from "./BaseInputMultiple.vue?vue&type=script&lang=js&"
export * from "./BaseInputMultiple.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputMultiple.vue?vue&type=style&index=0&id=bc63dfae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc63dfae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc63dfae')) {
      api.createRecord('bc63dfae', component.options)
    } else {
      api.reload('bc63dfae', component.options)
    }
    module.hot.accept("./BaseInputMultiple.vue?vue&type=template&id=bc63dfae&scoped=true&", function () {
      api.rerender('bc63dfae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputMultiple.vue"
export default component.exports